
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { openUiPanel } from "@/lib/panels/panels";

@Component({
  components: {}
})
export default class VariableChooserEmpty extends Vue {
  @Prop({ default: false })
  noResults!: boolean;

  @Prop({ default: false })
  noGlobal!: boolean;

  openVariablesPanel() {
    openUiPanel("variables");
  }
}
